// extracted by mini-css-extract-plugin
export var card = "_w4-0";
export var details = "_w4-1";